import Blank from "@/layouts/blank.vue";
import EmergencyOrderList from "@/pages/admin/emergency-order/EmergencyOrderList.vue";
import EmergencyOrderDetails from "@/pages/admin/emergency-order/EmergencyOrderDetails.vue";

const emergencyOrderRoutes = [
  {
    path: "emergency-order",
    name: "app-admin-emergency-order",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/emergency-order/list",
      },
      {
        path: "list",
        name: "app-admin-emergency-order-list",
        component: EmergencyOrderList,
      },
      {
        path: "details/:id",
        name: "app-admin-emergency-order-details-id",
        component: EmergencyOrderDetails,
      },
    ],
  },
];

export default emergencyOrderRoutes;
